import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionItemComponent } from 'src/app/components/accordion/accordion-item.component';
import { AccordionComponent } from 'src/app/components/accordion/accordion.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-privacy-policy',
  templateUrl:  `./${environment.pageFolder}/privacy-policy.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/privacy-policy.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [TranslateModule, AccordionComponent, AccordionItemComponent]
})
export class PrivacyPolicyComponent implements OnInit {
  allEvents: any;

  constructor() {}

  ngOnInit(): void {
    const loader = document.getElementById("loader-container")
    loader!.style.display = "none";
  }
}
